import React from "react";
import { T, useTranslateKey } from "../../hooks/useTranslate";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Radio,
} from "@mui/material";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { columns } from "../../screens/MyMembersScreen/format-members-columns";
import { styles } from "../../screens/PartnersScreen/partners.styles";


const SortMobile = ({
  sortModel,
  handleSortModelChange,
  loading,
  searchField
}) => {
  const [sortAnchorEl, setSortAnchorEl] = React.useState(null);
  const sortOpen = Boolean(sortAnchorEl);

  const field = [sortModel[0].field, sortModel[0].sort];

  const translateKey = useTranslateKey;

  const handleButtonClick = (event) => {
    const target = event.currentTarget;
    setSortAnchorEl(target);
  };

  const handleSortOptionClick = (e) => {
    ["desc", "asc"].includes(e.currentTarget.getAttribute("value"))
      ? handleSortModelChange([
        { field: field[0], sort: e.currentTarget.getAttribute("value") },
      ])
      : handleSortModelChange([
        { field: e.currentTarget.getAttribute("value"), sort: field[1] },
      ]);
    handleClose();
  };

  const handleClose = () => {
    setSortAnchorEl(null);
  };

  const textStyle = {
    fontFamily: "Inter",
    fontWeight: "500",
    fontSize: "14px"
  }
  return (
    <Box>
      <IconButton
        aria-label="open sort menu"
        id="sort-by-dropdown"
        aria-controls={sortOpen ? "sort-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={sortOpen ? "true" : undefined}
        onClick={handleButtonClick}
        style={sortOpen ? styles.selectedIcon : undefined}
        disabled={loading}
        sx={{
          border: "1px solid rgba(145, 158, 171, 0.2)",
          borderRadius: "8px",
          paddingTop: "9px",
          paddingBottom: "9px"
        }}
      >
        <ImportExportIcon />
      </IconButton>
      <Menu
        anchorEl={sortAnchorEl}
        open={sortOpen}
        onClose={handleClose}
        MenuListProps={{
          "id": "sort-menu",
          "aria-labelledby": "sort-by-dropdown",
        }}
        PaperProps={{
          style: {
            width: "100%",
            marginTop: "8px",
            borderRadius: "8px",
            border: "1px solid rgba(145, 158, 171, 0.1)",
            boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(145, 158, 171, 0.1)'
          },
        }}
      >
        <Box sx={styles.subheaderStyle}><T isUpperCase={true}>sort</T></Box>
        {columns.map(column => (
          <MenuItem
            aria-label={column.headerName}
            data-test-id={column.headerName}
            key={column.field}
            value={column.field}
            onClick={handleSortOptionClick}
            disabled={column.disableWhenNoSearch && !searchField}
          >
            <Radio
              checked={field.includes(column.field)}
              disabled={loading}
            />
            <ListItemText primary={translateKey(column.headerName)} primaryTypographyProps={textStyle} />
          </MenuItem>
        ))}
        <Box sx={styles.subheaderStyle}><T isUpperCase={true}>order</T></Box>
        <MenuItem
          key={"desc"}
          value={"desc"}
          data-test-id={`desc-listitem`}
          disabled={loading}
          onClick={handleSortOptionClick}
        >
          <Radio checked={field.includes("desc")} />
          <ListItemText primary={translateKey("descending")} primaryTypographyProps={textStyle} />
        </MenuItem>
        <MenuItem
          key={"asc"}
          value={"asc"}
          data-test-id={`asc-listitem`}
          disabled={loading}
          onClick={handleSortOptionClick}
        >
          <Radio checked={field.includes("asc")} disabled={loading} />
          <ListItemText primary={translateKey("ascending")} primaryTypographyProps={textStyle} />
        </MenuItem>
      </Menu>
    </Box>
  )
}

export { SortMobile }